import { render, staticRenderFns } from "./SaleTagsManagement.vue?vue&type=template&id=5a99ac30&"
import script from "./SaleTagsManagement.vue?vue&type=script&lang=js&"
export * from "./SaleTagsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports